module.exports = __webpack_public_path__ + "img/whatsapp-icon-desktop-en.7c4c8a3.png";